import React from 'react';
import * as stylex from '@stylexjs/stylex';
import { useDocumentTitle } from "usehooks-ts";
import { NavLink } from "react-router-dom";
import { queryStringMod } from "nood-comp/src/util/converters/converters";
import Flex from "nood-comp/src/comp/ui/containers/Flex";
import Text from "nood-comp/src/comp/text/Text";
import FlexVertical from "nood-comp/src/comp/ui/containers/flex-boxes/FlexVertical";
import Tag from "nood-comp/src/comp/ui/tag/Tag";
import Icon from "nood-comp/src/comp/ui/feather-icon/Icon";
import Table from "nood-comp/src/comp/data/table/Table";
import { date_util } from "nood-comp/src/util/date/DateUtil";
import { color } from "nood-comp/src/util/ui/color";
var STATUS_COLORS = {
  ACTIVE: '#88c9a0',
  PAUSED: '#c0aa85',
  EXPIRED: '#be8484',
  ARCHIVED: '#6b7280'
};
var ACTION_LABELS = {
  GRANT_TIER: 'Grant Tier',
  APPLY_DISCOUNT_FIXED: 'Discount Fixed',
  APPLY_DISCOUNT_PERCENT: 'Discount %'
};
export default function VoucherCampaigns() {
  useDocumentTitle("Evnts: Campaigns");
  return /*#__PURE__*/React.createElement(Table, {
    data_source: "/voucher-campaigns",
    rowPadding: 5,
    cols: [{
      property: "code",
      label: "Campaign",
      filterType: "text",
      icon: "tag",
      filterPlaceholder: "Code or Name",
      to: function to(obj, idx) {
        return queryStringMod({
          "do": "view",
          id: obj.id
        });
      },
      content: function content(obj) {
        return /*#__PURE__*/React.createElement(Flex, {
          gap: 8
        }, /*#__PURE__*/React.createElement(FlexVertical, null, /*#__PURE__*/React.createElement(Text, null, obj.code), /*#__PURE__*/React.createElement(Text, null, obj.name)));
      }
    }, {
      label: "Action",
      width: 130,
      content: function content(obj) {
        var _ACTION_LABELS$obj$ac;
        return /*#__PURE__*/React.createElement(Tag, {
          value: (_ACTION_LABELS$obj$ac = ACTION_LABELS[obj.action_type]) !== null && _ACTION_LABELS$obj$ac !== void 0 ? _ACTION_LABELS$obj$ac : obj.action_type,
          color: "var(--accent)",
          textColor: "var(--text-on-accent)",
          style: {
            fontSize: 11,
            padding: "2px 6px",
            borderRadius: 4
          }
        });
      }
    }, {
      label: "Status",
      width: 90,
      content: function content(obj) {
        var _STATUS_COLORS$obj$st, _STATUS_COLORS$obj$st2;
        return /*#__PURE__*/React.createElement(Tag, {
          value: obj.status,
          color: (_STATUS_COLORS$obj$st = STATUS_COLORS[obj.status]) !== null && _STATUS_COLORS$obj$st !== void 0 ? _STATUS_COLORS$obj$st : '#6b7280',
          textColor: color.determineCorrectTextContrast((_STATUS_COLORS$obj$st2 = STATUS_COLORS[obj.status]) !== null && _STATUS_COLORS$obj$st2 !== void 0 ? _STATUS_COLORS$obj$st2 : '#6b7280'),
          style: {
            fontSize: 11,
            padding: "2px 6px",
            borderRadius: 4,
            textTransform: "uppercase"
          }
        });
      }
    }, {
      label: "Validity",
      width: 160,
      content: function content(obj) {
        return /*#__PURE__*/React.createElement(FlexVertical, {
          gap: 2
        }, /*#__PURE__*/React.createElement(Text, {
          style: {
            fontSize: 12
          }
        }, obj.valid_from ? date_util.as_local(obj.valid_from, 'mmm dd, yyyy') : '—'), /*#__PURE__*/React.createElement(Text, {
          style: {
            fontSize: 12,
            color: "var(--shade-40)"
          }
        }, obj.valid_until ? date_util.as_local(obj.valid_until, 'mmm dd, yyyy') : '∞'));
      }
    }, {
      label: "Redeem",
      width: 100,
      content: function content(obj) {
        var _obj$max_redemptions, _obj$max_redemptions_;
        return /*#__PURE__*/React.createElement(FlexVertical, {
          gap: 2,
          style: {
            fontSize: 12
          }
        }, /*#__PURE__*/React.createElement(Text, null, (_obj$max_redemptions = obj.max_redemptions) !== null && _obj$max_redemptions !== void 0 ? _obj$max_redemptions : '∞', " total"), /*#__PURE__*/React.createElement(Text, {
          style: {
            color: "var(--shade-40)"
          }
        }, (_obj$max_redemptions_ = obj.max_redemptions_per_user) !== null && _obj$max_redemptions_ !== void 0 ? _obj$max_redemptions_ : '∞', " / user"));
      }
    }, {
      width: 40,
      label: "",
      content: function content(obj) {
        return /*#__PURE__*/React.createElement(NavLink, {
          to: queryStringMod({
            "do": "edit",
            id: obj.id
          })
        }, /*#__PURE__*/React.createElement(Icon, {
          icon: "edit-2"
        }));
      }
    }]
  });
}

// @ts-ignore